export const REGIONS = [
  { name: "Northland", slug: "northland" }, { name: "Auckland", slug: "auckland" },
  { name: "Waikato", slug: "waikato" }, { name: "Bay of Plenty", slug: "bayofplenty" },
  { name: "Gisborne", slug: "gisborne" }, { name: "Hawke's Bay", slug: "hawkesbay" },
  { name: "Taranaki", slug: "taranaki" }, { name: "Manawatu", slug: "manawatu" },
  { name: "Wellington", slug: "wellington" }, { name: "Tasman", slug: "tasman" },
  { name: "Nelson", slug: "nelson" }, { name: "Marlborough", slug: "marlborough" },
  { name: "West Coast", slug: "westcoast" }, { name: "Canterbury", slug: "canterbury" },
  { name: "Otago", slug: "otago" }, { name: "Southland", slug: "southland" },
];
export const REGION_NAMES = REGIONS.map((r) => r.name);
export const regionByName = (name) => REGIONS.find((r) => r.name === name) || null;
export const homeFor = (role) => (role === "admin" ? "/admin" : role === "operator" ? "/operator" : "/dashboard");

// Regional site = <slug>.markdowns.nz, or ?site=<slug> for previewing (cleared with ?site=)
function detectSiteRegion() {
  if (typeof window === "undefined") return null;
  const m = window.location.hostname.toLowerCase().match(/^([a-z]+)\.markdowns\.nz$/);
  let slug = m && m[1] !== "www" ? m[1] : null;
  const qp = new URLSearchParams(window.location.search).get("site");
  if (qp !== null) {
    if (qp) sessionStorage.setItem("bb_site", qp);
    else sessionStorage.removeItem("bb_site");
  }
  slug = slug || sessionStorage.getItem("bb_site");
  return REGIONS.find((r) => r.slug === slug) || null;
}

export const SITE_REGION = detectSiteRegion();
